import { z } from "zod";

// ── Enums ──

export enum MessageType {
	INTRO = "INTRO",
	FOLLOW_UP = "FOLLOW_UP",
	BREAKUP = "BREAKUP",
}

// ── Sub-schemas ──

export const ExampleMessageSchema = z.object({
	language: z.string(),
	messages: z.array(z.string()),
});

export type ExampleMessage = z.infer<typeof ExampleMessageSchema>;

// ── Response schema ──

export const CopywritingFrameworkSchema = z.object({
	id: z.number(),
	name: z.string(),
	description: z.string(),
	structure: z.string(),
	exampleMessages: z.array(ExampleMessageSchema).nullable(),
	applicableTo: z.array(z.nativeEnum(MessageType)),
	whenToUse: z.string(),
	whenNotToUse: z.string().nullable().optional(),
	enabled: z.boolean(),
	isDefault: z.boolean(),
	companyId: z.number(),
	createdAt: z.string(),
	updatedAt: z.string(),
});

export type CopywritingFramework = z.infer<typeof CopywritingFrameworkSchema>;

// ── List response (no pagination — returns all) ──

export const CopywritingFrameworkListResponseSchema = z.array(CopywritingFrameworkSchema);

export type CopywritingFrameworkListResponse = z.infer<
	typeof CopywritingFrameworkListResponseSchema
>;

// ── Create body schema (form validation) ──

export const CreateCopywritingFrameworkSchema = z.object({
	name: z.string().min(1, { message: "Required" }).trim(),
	description: z.string().min(1, { message: "Required" }).trim(),
	structure: z.string().min(1, { message: "Required" }).trim(),
	exampleMessages: z.array(ExampleMessageSchema).optional(),
	applicableTo: z.array(z.nativeEnum(MessageType)).min(1, { message: "Required" }),
	whenToUse: z.string().min(1, { message: "Required" }).trim(),
	whenNotToUse: z.string().optional(),
});

export type CreateCopywritingFramework = z.infer<typeof CreateCopywritingFrameworkSchema>;

// ── Update body schema (all optional) ──

export const UpdateCopywritingFrameworkSchema = z.object({
	name: z.string().min(1).trim().optional(),
	description: z.string().min(1).trim().optional(),
	structure: z.string().min(1).trim().optional(),
	exampleMessages: z.array(ExampleMessageSchema).optional(),
	applicableTo: z.array(z.nativeEnum(MessageType)).min(1).optional(),
	whenToUse: z.string().min(1).trim().optional(),
	whenNotToUse: z.string().optional(),
});

export type UpdateCopywritingFramework = z.infer<typeof UpdateCopywritingFrameworkSchema>;
